import { cloneElement } from 'react';
import { useBi, useEnvironment } from '@wix/yoshi-flow-editor';
import { useHref, useRouter } from '../hooks';
export function UISref(props) {
  const {
    state,
    params,
    options,
    disabled,
    children,
    bi: biProps,
    ...rest
  } = props;
  const {
    isViewer
  } = useEnvironment();
  const bi = useBi();
  const router = useRouter();
  const href = useHref(state, params, options);
  if (disabled) {
    return /*#__PURE__*/cloneElement(children, rest);
  }
  return /*#__PURE__*/cloneElement(children, {
    href: isViewer ? href : undefined,
    onClick: handleClick,
    ...children.props,
    ...rest
  });
  function handleClick(event) {
    if (biProps) {
      bi.report(biProps);
    }

    // viewer is using [href]
    if (isViewer) {
      return;
    }
    handleNavigation(event);
  }
  function handleNavigation(event) {
    event.preventDefault();
    event.stopPropagation();
    router.go(state, params, options);
  }
}
UISref.defaultProps = {
  options: {
    absolute: true
  }
};
UISref.displayName = 'UISref';
//# sourceMappingURL=UISref.js.map